import { DisabledPrompt, Link, useStateManager } from "@bcm-dev/bcms-vite";
import CustomSelect, { CustomAccountSelect, CustomSelectItem } from 'components/custom-ui/CustomSelect';
import UIRadioGroup, { UIRadio } from 'components/custom-ui/UIRadioGroup';
import { FormContainer, FormRowView, WidgetContainer, WidgetView } from 'components/shared';
import { FormButtonRow } from 'components/shared/containers/FormContainer';
import { PrimaryButton, SecondaryButton, UIAmountInput, UICheckbox } from 'components/ui';
import { Account, UserAccount } from "model";
import React from 'react';
import "./styles.css";
import "./mobile.css";


/**
 * @function AddEditAlertWidget
 * @return {React.Component}
 * @exported true
 * @description description
 */

export default function AddEditAlertWidget(props) {
    const { data, ui, onAccountChange, onAddSubscriptionClick, onCancelClick, onChange, onChangePhoneEmail, onSubmitClick } = useStateManager();
    const widgetID = "addEditAlertWidget";
    const alert = data[widgetID].alert;

    const phoneCheckboxes = data[widgetID].allUserAccountsIDsForPhone.reduce((acc, item) => {
        const userAccount = UserAccount.initByID(item);
        const isSelected = alert.userAccountIDsForPhone.includes(userAccount.id);
        acc.push(<UICheckbox key={ userAccount.id } dataPoint={ `Add_Edit_Alert_Widget_Phone_${ userAccount.id }` } label={ userAccount.workPhoneNumber } value={ isSelected } onChange={ onChangePhoneEmail("phone", userAccount.id) } />)
        return acc;
    }, []);
    
    const emailCheckboxes = data[widgetID].allUserAccountsIDsForEmail.reduce((acc, item) => {
        const userAccount = UserAccount.initByID(item);
        const isSelected = alert.userAccountIDsForEmail.includes(userAccount.id);
        acc.push(<UICheckbox key={ userAccount.id } dataPoint={ `Add_Edit_Alert_Widget_Email_${ userAccount.id }` } label={ userAccount.emailAddress } value={ isSelected } onChange={ onChangePhoneEmail("email", userAccount.id) } />)
        return acc;
    }, []);

  return(
    <WidgetContainer className="add-edit-alert">
      <WidgetView dataPoint={ `Add_Edit_Alert_Widget_Title` } text="Add/Edit an Alert">
        <FormContainer className="small-form-width alert-form">
            { !ui[widgetID].form.isActive && 
            <FormRowView text="Alert Type">
                <CustomSelect active={ ui[widgetID].alertTypeSelect.isActive } dataPoint={ `Add_Edit_Alert_Widget_Select_Alert_Type` } value={ alert.type } onChange={ onChange("type") }>
                    <CustomSelectItem value="prompt">-- Select an Alert Type --</CustomSelectItem>
                    <CustomSelectItem value="balanceAlert">
                      <span data-point={ `Add_Edit_Alert_Widget_Option_Balance_Alert` }>Balance Alert</span>
                    </CustomSelectItem>
                    <CustomSelectItem value="checkClearedAlert">Check Cleared Alert</CustomSelectItem>
                    <CustomSelectItem value="dailyBalanceAlert">Daily Balance Alert</CustomSelectItem>
                    <CustomSelectItem value="loanDueAlert">Loan Due Alert</CustomSelectItem>
                    <CustomSelectItem value="maturityAlert">Maturity Alert</CustomSelectItem>
                    <CustomSelectItem value="transactionAlert">Transaction Alert</CustomSelectItem>
                    <CustomSelectItem value="cardAlert">Card Alert</CustomSelectItem>
                    <CustomSelectItem value="secureMessageAlert">Secure Message Alert</CustomSelectItem>
                </CustomSelect>
            </FormRowView>
            }
          { !ui[widgetID].form.isActive && 
            <FormButtonRow>
                { alert.type === "balanceAlert" &&
                <PrimaryButton className="add-sub-button" dataPoint={ `Add_Edit_Alert_Widget_Add_Subscription_Button` } text="Add Subscription" onClick={ onAddSubscriptionClick } />
                }
                { alert.type !== "balanceAlert" &&
                <div className="flex-width disabled-button-container">
                <DisabledPrompt>
                    <PrimaryButton className="add-sub-button" dataPoint={ `Add_Edit_Alert_Widget_Add_Subscription_Button` } text="Add Subscription" onClick={ onAddSubscriptionClick } />
                </DisabledPrompt>
                </div>
                
                }
            </FormButtonRow>
          }
          { ui[widgetID].form.isActive && 
          <>
          <FormRowView text="On Account:">
            <CustomAccountSelect onChange={ onAccountChange("account") } dataPoint={ `Add_Edit_Alert_Widget_Account_Select` } 
            active={ ui[widgetID].formAccountSelect.isActive } value={ Account.initByType(alert.account.id) } accounts={ Account.initAll() } />
          </FormRowView>
          <FormRowView text="Alert me when">
            <UIRadioGroup value={ alert.alertMeWhen } onChange={ onChange("alertMeWhen") }>
                <UIRadio dataPoint={ `Add_Edit_Alert_Widget_Option_Available_Balance` } value="available balance" label="Available Balance" name="alert-when" />
                <UIRadio dataPoint={ `Add_Edit_Alert_Widget_Option_Actual_Balance` } value="actual balance" label="Actual Balance" name="alert-when" />
            </UIRadioGroup>
            
          </FormRowView>
          <FormRowView text="changes and is:">
            <UIRadioGroup value={ alert.alertMeWhenBalanceIs } onChange={ onChange("alertMeWhenBalanceIs") }>
                <UIRadio dataPoint={ `Add_Edit_Alert_Widget_Option_Less_Than` } value="less than" label="Less than" name="changes-is" />
                <UIRadio value="less than or equal to" label="Less than or equal to" name="changes-is" />
                <UIRadio value="equal to" label="Equal to" name="changes-is" />
                <UIRadio value="not equal to" label="Not equal to" name="changes-is" />
                <UIRadio value="greater than or equal to" label="Greater than or equal to" name="changes-is" />
                <UIRadio value="greater than" label="Greater than" name="changes-is" />
            </UIRadioGroup>
          </FormRowView>

          <FormRowView text="Balance threshold amount">
            <UIAmountInput dataPoint={ `Add_Edit_Alert_Widget_Input_Balance_Threshold_Amount` } value={ alert.balanceThresholdAmount ? alert.balanceThresholdAmount.amount : undefined } 
            onChange={ onChange("balanceThresholdAmount") } />
          </FormRowView>

          <FormRowView text="Phone numbers" className="phone-row">
            <DisabledPrompt>
              <Link>
                <span data-point={ `Add_Edit_Alert_Widget_Link_Add_Edit_Phone` }>Add/Edit Phone</span>
              </Link>
            </DisabledPrompt>
            { phoneCheckboxes }
          </FormRowView>

          <FormRowView text="Email Addresses" className="email-address-row">
            <DisabledPrompt>
              <Link>
                <span data-point={ `Add_Edit_Alert_Widget_Link_Add_Edit_Email` }>Add/Edit Email</span>
              </Link>
            </DisabledPrompt>
            { emailCheckboxes }
          </FormRowView>

          <FormButtonRow>
            <SecondaryButton text="Cancel" onClick={ onCancelClick } />
            <PrimaryButton dataPoint={ `Add_Edit_Alert_Widget_Submit_Button` } text="Submit" onClick={ onSubmitClick } />
          </FormButtonRow>
          </>
          }
        </FormContainer>
      </WidgetView>
    </WidgetContainer>
  );
}